// Auto-generated translation for zh.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:47:32.324036+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "适合马匹主人",
    title: "为您的马匹，一切尽在一款应用。",
    subtitle: "在一个清晰的档案中管理健康、训练、日程安排和专业人员。",
    primaryCTA: {
      label: "免费开始",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看 Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "马匹档案 — 体重、疫苗接种、EquiCoach、饮食与训练尽在一屏",
      caption: "您的马匹，全貌尽览。",
    },
    problem: "您现在可能将预约、照片、训练、饮食和健康信息分散存放在 WhatsApp 群组、纸质文件和各种应用中，导致缺乏全局视图。",
    solution: "EquiSight 将您的马匹信息整合为一份完整的数字档案，随时随地伴您左右。",
    benefits: [
      "每匹马一份完整的马匹档案",
      "健康、蹄铁匠、牙医和理疗信息集中一处",
      "带智能提醒的日历",
      "无限量照片、备注和历史记录",
      "Premium 版本提供全部数据备份",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1匹马 · 永久免费",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "多匹马 + 数据备份",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好开始了吗？",
      title: "今天就为您的第一匹马建立档案。",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "更多马匹。更清晰的管理。更大的保障。",
    subtitle: "升级至 Premium，无限制管理您所有的马匹——享受完整的 EquiCoach 智能分析。",
    primaryCTA: {
      label: "免费试用 14 天",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "所有价格方案",
      href: "/#pricing",
    },
    audience: "专为拥有多匹马的马主、运动骑手及养马人设计。",
    features: [
      "无限添加马匹",
      "每匹马的完整历史记录",
      "数据备份",
      "深度 EquiCoach 智能洞察",
      "智能提醒与日程规划",
      "健康与训练数据全面关联",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "每天不到 €0,17",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "立即升级至 Premium。",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "适合马术学校骑手",
    title: "不断进步，即使没有自己的马。",
    subtitle: "在 EquiSight 中跟踪您的课程、训练和成长——每月花费不到一杯咖啡的价格。物超所值，轻松出发。",
    primaryCTA: {
      label: "开始使用 Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "如何使用？",
      href: "#features",
    },
    problem: "作为马术学校的骑手，您通常没有自己的马，但您仍然希望不断进步，并清晰掌握自己的课程、目标以及所骑乘的马匹信息。",
    solution: "马术学校功能已内置于 Premium 计划中——跟踪您自己的成长历程，并以只读方式查看关联的马术学校马匹信息。",
    features: [
      "记录训练情况",
      "设定目标",
      "追踪进步",
      "查看马术学校马匹的名称和照片",
      "无法访问私人健康数据",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "每月 · 含马术学校功能",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "立即加入",
      title: "以马术学校骑手身份开始。",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "适用于马术学校和马厩",
    title: "让您的马术学校对每位骑手实现数字化开放。",
    subtitle: "为骑手提供与马匹、课程和进度的连接——无需共享敏感的马厩数据。",
    primaryCTA: {
      label: "申请访问权限",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看模块",
      href: "#features",
    },
    audience: "EquiSight 帮助马术学校和马厩让骑手保持更长时间的参与度，并在数字化方面脱颖而出。",
    features: [
      "让骑手看到马术学校的马匹",
      "每匹马的姓名和照片",
      "将骑手与马匹关联",
      "对隐私敏感数据的只读访问",
      "集中管理课程和训练历史",
      "基于角色的用户管理",
    ],
    benefits: [
      "与骑手建立更强的连接",
      "更专业的品牌形象",
      "为会员提供额外的数字化服务",
      "通过应用使用开拓新的收入来源",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "每月 · 骑手的马术学校功能已包含在内",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "激活马术学校模块。",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "繁育模块",
    title: "掌控发情周期、妊娠期与幼驹发育。",
    subtitle: "专为母马主人与育种者打造的完整繁育模块——从配种到幼驹诞生，一条时间轴全程记录。",
    primaryCTA: {
      label: "激活繁育模块",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看功能",
      href: "#features",
    },
    audience: "适用于育种者、母马主人及管理多匹母马的马厩。",
    features: [
      "发情周期追踪",
      "发情期记录",
      "授精日期登记",
      "超声检查倒计时",
      "妊娠检查计划",
      "血统与谱系管理",
      "幼驹发育跟踪",
      "所有妊娠母马总览",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "每月 · Pro 套餐已包含繁育模块",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "立即开始",
      title: "开启繁育管理之旅。",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "蹄铁师模块",
    title: "更智能地工作，专业记录每一个细节。",
    subtitle: "日程、照片、备注和治疗历史集于一个模块——减少沟通误差，建立更完善的档案。",
    primaryCTA: {
      label: "以蹄铁师身份开始",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看 Professional 套餐",
      href: "/professional",
    },
    audience: "适合希望改善管理概览、提供证明材料及客户沟通的蹄铁师。",
    features: [
      "个人日程",
      "按客户管理预约",
      "查看马匹档案",
      "添加治疗前后照片",
      "记录治疗内容",
      "记录建议与备注",
      "向客户发送预计到达通知：\"蹄铁师正在赶来\"",
    ],
    benefits: [
      "更专业的工作方式",
      "减少沟通误差",
      "更完善的档案建立",
      "责任追溯更有力",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "每月 · 蹄铁师模块包含在 Professional 套餐中",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "激活蹄铁师模块。",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "牙科模块",
    title: "每匹马一份完整的牙科档案。",
    subtitle: "直接在 EquiSight 中记录检查结果、治疗方案和后续跟进。",
    primaryCTA: {
      label: "以马匹牙医身份开始",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看 Professional 套餐",
      href: "/professional",
    },
    audience: "希望规范化工作流程的马匹牙医、兽医及诊所。",
    features: [
      "记录牙齿检查",
      "每次治疗的检查结果",
      "添加照片",
      "向马主出具报告",
      "后续跟进建议",
      "每匹马的历史记录",
      "安排新预约",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "每月 · Professional 套餐已包含牙科模块",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "激活牙科模块。",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "物理治疗 / 整骨模块",
    title: "专业追踪马匹身体状况、运动表现与康复进程。",
    subtitle: "专为希望系统性管理马匹的物理治疗师和整骨师设计。",
    primaryCTA: {
      label: "以物理治疗师/整骨师身份开始",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看 Professional 套餐",
      href: "/professional",
    },
    features: [
      "每匹马的接诊记录",
      "记录身体检查结果",
      "添加照片和视频",
      "生成治疗报告",
      "分享练习计划与跟进事项",
      "追踪康复进程",
      "每匹马的历史记录",
    ],
    benefits: [
      "随时间推移获得更深入的洞察",
      "专业级报告输出",
      "与马主、训练师和骑手之间的清晰沟通",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "每月 · Professional 套餐已包含物理治疗 / 整骨模块",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "激活物理治疗 / 整骨模块。",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "教练模块",
    title: "用数据、目标和进度辅导骑手。",
    subtitle: "让训练可量化、指导更专业——适用于一位或多位骑手。",
    primaryCTA: {
      label: "以教练身份开始",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看 Pro 套餐",
      href: "/#pricing",
    },
    audience: "适合拥有多位骑手或马匹的教练、训练师和指导员。",
    features: [
      "关联骑手",
      "追踪马匹",
      "设定训练目标",
      "提供反馈",
      "分析比赛成绩",
      "查看每组合的进度",
      "使用协议分析确定训练重点",
    ],
    benefits: [
      "更好的指导",
      "更强的条理性",
      "更专业的沟通",
      "与客户建立更深的联系",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "每月 · Pro 套餐已包含教练模块",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "激活教练模块。",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "比赛分析",
    title: "从成绩单到成绩提升。",
    subtitle: "上传您的比赛成绩单，发现失分之处——不只是查看分数，而是真正理解如何进步。",
    primaryCTA: {
      label: "分析您的第一份成绩单",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看 Premium",
      href: "/premium",
    },
    features: [
      "上传成绩单照片",
      "处理正反两面",
      "识别组别、测试编号及裁判员",
      "按项目分析得分",
      "汇总评语",
      "展示优势与不足",
      "按马匹-骑手组合追踪趋势",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "每月 · Premium 起包含比赛分析功能",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "开始使用比赛分析功能。",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional 套餐",
    title: "专为马匹专业人士打造。",
    subtitle: "蹄铁师、牙医、理疗师、整骨师或训练师：在同一个数字马匹档案中协同工作。",
    primaryCTA: {
      label: "以专业人士身份开始",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "查看各独立模块",
      href: "#features",
    },
    audience: "Professional 套餐将所有专业模块整合于一个订阅中。",
    features: [
      "蹄铁师模块",
      "牙医模块",
      "理疗／整骨模块",
      "日程与客户管理",
      "马匹档案与报告",
      "治疗历史与病历构建",
      "与马主的沟通",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "每月 · 包含所有专业模块",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "准备好了吗？",
      title: "选择 Professional。",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "马匹紧急联系号码",
    title: "随时获得正确的帮助，触手可及。",
    subtitle: "紧急情况下，每一秒都至关重要。使用 EquiSight，您可以立即获取马匹的所有重要联系信息——一键即可拨打电话。",
    primaryCTA: {
      label: "准备好您的紧急联系人",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "免费开始使用 EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "紧急联系人——直接拨打电话、发送 WhatsApp 消息或导航至兽医、诊所和蹄铁匠处",
      caption: "一键操作，无需慌乱查找。",
      embeddedFrame: true,
    },
    problem: "您的马出现了状况——腹痛、受伤、惊慌。然后开始手忙脚乱地查找：该打给谁？有没有正确的号码？这是急诊号码吗？宝贵的时间就这样白白流失了。",
    solution: "使用 EquiSight，一切信息唾手可得。无需查找，无需犹豫。一键即可取得联系。",
    scenario: {
      title: "想象一下——您的马出现了腹痛症状。",
      steps: [
        "打开 EquiSight",
        "点击\"兽医\"",
        "直接拨打电话",
      ],
      tagline: "无需紧张，无需查找，只需行动。",
    },
    features: [
      "所有紧急号码集中一处",
      "在应用内一键拨号",
      "一键发送 WhatsApp 消息",
      "直接导航至目的地地址",
      "每匹马拥有专属联系人列表",
      "兽医、诊所、蹄铁匠、牙医、理疗师",
      "地址及路线说明即时可用",
      "用星标标记常用号码",
      "急救号码（112、144）始终置顶",
    ],
    benefits: [
      "紧急情况下保持镇定与掌控",
      "马厩中所有人随时共享相同号码",
      "再也不会忘记名片",
      "紧急情况下响应速度提升数秒",
    ],
    audience: "适用于马主、护理人员、教练和马厩管理者——所有对马匹负有责任的人。",
    showcase: {
      eyebrow: "已为您预先配置完毕",
      title: "13 个联系人类别——随时可填写。",
      description: "从兽医和急诊诊所，到鞍具师、教练和牧场管理员，EquiSight 了解您的世界，并为您预设好正确的联系人字段。点击、填写、完成。",
      bullets: [
        "急救与健康——兽医、急诊、诊所、中毒热线",
        "日常护理——蹄铁匠、牙医、理疗师、教练",
        "马厩与牧场——马厩主、牧场管理员、寄宿马厩",
        "饲料与物资——干草、精饲料、垫草供应商",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "紧急联系人管理界面——按类别显示所有建议联系人",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "马匹紧急号码清单",
      items: [
        "兽医",
        "急诊诊所（24/7）",
        "动物救护车 · 144",
        "蹄铁匠",
        "备用联系人",
        "通用报警号码 · 112",
      ],
      cta: {
        label: "在 EquiSight 中打开并立即填写",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "紧急号码",
          price: "免费",
          note: "永久免费 · 适用于所有人及所有订阅方案",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "做好万全准备",
      title: "在需要之前。",
      href: "/#waitlist",
    },
    microcopy: [
      "无任何义务",
      "2 分钟内完成设置",
      "随时可修改",
    ],
  },
};

export default LANDINGS;
